<script setup lang="ts">
import { computed } from 'vue';

import { useAuthImage } from '../composables/useAuthImage';

const props = defineProps<{
    src: string | null | undefined
    alt?: string
}>();

const srcRef = computed(() => props.src);
const objectUrl = useAuthImage(srcRef);
</script>

<template>
    <img
        v-if="objectUrl"
        :src="objectUrl"
        :alt="alt ?? ''"
        v-bind="$attrs"
    />
</template>
